export default __webpack_public_path__ + "static/media/ic_setting_noti.11577e6d.svg";